import { useAuth0 } from "@auth0/auth0-react";
import { authorizationParams } from "constant/commonConstant";
import React, { FC, useEffect } from "react";
import * as authHelper from "../helpers/AuthHelpers";

const RefreshTokenTrigger: FC<{ children: any }> = ({ children }) => {
  const { getAccessTokenSilently, isAuthenticated, loginWithRedirect } =
    useAuth0();
  const refreshTockenHanlder = async () => {
    try {
      const accessToken = await getAccessTokenSilently({
        cacheMode: "off",
        authorizationParams: authorizationParams,
      });
      authHelper.setSubscriptionAccessToken(accessToken);
    } catch (error) {
      console.error("Error refreshing token:", error);
      loginWithRedirect();
    }
  };
  useEffect(() => {
    if (isAuthenticated) refreshTockenHanlder();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuthenticated]);
  return <>{children}</>;
};

export default RefreshTokenTrigger;
